import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export function VisualProofSection() {
  return <section className="w-full bg-[#0b0b0b] py-10 md:py-16 px-4 relative overflow-hidden border-t border-white/5" data-id="element-379">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-380">
        <div className="text-center mb-10 md:mb-16" data-id="element-381">
          <h2 className="text-2xl md:text-5xl font-black text-white leading-tight mb-4" data-id="element-382">
            La diferencia no es la máquina…{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-383">
              es el método.
            </span>
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-[#c9a24a] to-[#b8913f] mx-auto rounded-full" data-id="element-384"></div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-8 mb-8 md:mb-12" data-id="element-385">
          {/* LEFT: Bad Fade */}
          <div className="bg-[#141418] border border-white/10 rounded-xl md:rounded-2xl overflow-hidden flex flex-col" data-id="element-386">
            <div className="bg-red-500/10 border-b border-red-500/20 p-2 md:p-4 text-center" data-id="element-387">
              <p className="text-red-400 text-[10px] md:text-sm font-black uppercase tracking-widest flex items-center justify-center gap-1.5" data-id="element-388">
                <XCircleIcon className="w-3 h-3 md:w-5 md:h-5" data-id="element-389" />
                Sin método
              </p>
            </div>
            <div className="aspect-square bg-[#0b0b0b] relative overflow-hidden border-b border-white/5" data-id="element-390">
              <img src="https://cdn.magicpatterns.com/uploads/jf1YXuSE9aXFDdqgS16doG/d51568ca638e402876cb6f1dfd3b1ec5.jpg" alt="Corte sin método — transición irregular" className="w-full h-full object-cover" data-id="element-391" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141418] to-transparent opacity-40" data-id="element-392"></div>
            </div>
            <div className="p-3 md:p-6 bg-gradient-to-b from-[#141418] to-[#0b0b0b]" data-id="element-393">
              <ul className="space-y-2" data-id="element-394">
                {['Corte "a ojo"', 'Inseguridad al borrar líneas', 'Resultado amateur'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-400" data-id="element-395">
                    <XCircleIcon className="w-3 h-3 md:w-4 md:h-4 text-red-500/70 flex-shrink-0 mt-0.5" data-id="element-396" />
                    <span className="text-[9px] md:text-sm" data-id="element-397">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* RIGHT: Good Fade */}
          <div className="bg-[#141418] border-2 border-[#c9a24a]/30 rounded-xl md:rounded-2xl overflow-hidden flex flex-col shadow-[0_0_30px_rgba(201,162,74,0.1)] relative" data-id="element-398">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-399"></div>
            <div className="bg-[#c9a24a]/10 border-b border-[#c9a24a]/20 p-2 md:p-4 text-center" data-id="element-400">
              <p className="text-[#c9a24a] text-[10px] md:text-sm font-black uppercase tracking-widest flex items-center justify-center gap-1.5" data-id="element-401">
                <CheckCircleIcon className="w-3 h-3 md:w-5 md:h-5" data-id="element-402" />
                Con Método Barber Pro
              </p>
            </div>
            <div className="aspect-square bg-[#0b0b0b] relative overflow-hidden border-b border-white/5" data-id="element-403">
              <img src="https://cdn.magicpatterns.com/uploads/jRR6WZzHDwKDTK8EAAifoy/DEGRADADO_EN_PICO_HOMBRE.png" alt="Degradado en pico profesional con Método Barber Pro" className="w-full h-full object-cover" data-id="element-404" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141418] to-transparent opacity-30" data-id="element-405"></div>
            </div>
            <div className="p-3 md:p-6 bg-gradient-to-b from-[#141418] to-[#0b0b0b]" data-id="element-406">
              <ul className="space-y-2" data-id="element-407">
                {['Estructura paso a paso', 'Control total de la máquina', 'Acabado premium'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-408">
                    <CheckCircleIcon className="w-3 h-3 md:w-4 md:h-4 text-[#c9a24a] flex-shrink-0 mt-0.5" data-id="element-409" />
                    <span className="text-[9px] md:text-sm font-semibold" data-id="element-410">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-411">
          <p className="text-gray-500 text-xs md:text-base font-medium uppercase tracking-widest" data-id="element-412">
            La técnica marca la diferencia. No la herramienta.
          </p>
        </div>
      </div>
    </section>;
}